import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios';
import flatpickr from 'flatpickr';

import router from './routes';
import store from './store/index';
import ContactFormValidator from '../validation/ContactFormValidator';

window.axios = axios;
window.ContactFormValidator = ContactFormValidator;

Vue.use(VueRouter);

router.beforeEach((to, from, next) => {
    if (to.query.electric && to.query.electric == 1) {
        store.commit('setOnlyElectric', 1);
    }
    next();
});

const app = new Vue({
    el: '#test-drive',
    mixins: [{
        methods: {
            flatpickr
        }
    }],
    router,
    store,
});